import { useState } from 'react';
import { NavHashLink } from "react-router-hash-link";
import { Link } from 'react-router-dom';
import useScrollPosition from "../../hooks/useScrollPosition";
import '../../styles/navbar.scss';


const Navbar = () => {

  const scrollPosition = useScrollPosition();

  const [isNavbarShowing, setNavbarShowing] = useState(false);

  return (
    <nav className={`navbar ${scrollPosition > 0 ? 'navbar__scrolled' : ''}`}>
      <div className="navbar__left">
        <NavHashLink smooth replace className="navbar__left--link" to={'/#header'} data-cursor-enlarge="true">
          <img className="navbar__left--img" src='./images/dsclogo.png' alt='Navbar Logo' data-cursor-enlarge="true" />
        </NavHashLink>
      </div>
      <div className="navbar__right">
        <div className={`navbar__links ${isNavbarShowing ? 'navbar__links--show' : ''}`}>
          <NavHashLink smooth replace className="navbar__right--link" to={'/#about'} onClick={() => setNavbarShowing(false)} data-cursor-enlarge="true">
            <span data-cursor-enlarge="true">About</span>
          </NavHashLink>
          <NavHashLink smooth replace className="navbar__right--link" to={'/#team'} onClick={() => setNavbarShowing(false)} data-cursor-enlarge="true">
            <span data-cursor-enlarge="true">Team</span>
          </NavHashLink>
          <NavHashLink smooth replace className="navbar__right--link" to={'/#events'} onClick={() => setNavbarShowing(false)} data-cursor-enlarge="true">
            <span data-cursor-enlarge="true">Workshops</span>
          </NavHashLink>
          <NavHashLink smooth replace className="navbar__right--link" to={'/#guests'} onClick={() => setNavbarShowing(false)} data-cursor-enlarge="true">
            <span data-cursor-enlarge="true">Guests</span>
          </NavHashLink>
          <Link className="navbar__right--link" to={'/codeofconduct'} onClick={() => setNavbarShowing(false)} data-cursor-enlarge="true">
            <span data-cursor-enlarge="true">Code of Conduct</span>
          </Link>
        </div>

        <div data-cursor-enlarge="true" className={`navbar__ham ${isNavbarShowing ? 'navbar__ham--show' : ''}`} onClick={() => setNavbarShowing(prev => !prev)}>
          <div className='navbar__ham--icon' data-cursor-enlarge="true">&nbsp;</div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar;